import { Controller } from 'stimulus';
import getControllerForElement from '@/helpers/getControllerForElement';

const toArray = (nodeList) => Array.prototype.slice.call(nodeList);

class ShippingPageController extends Controller {
  connect() {
    this.handleShippingCosts();
  }

  onShippingChange() {
    this.handleShippingCosts();
  }

  /**
   * @return {HTMLInputElement|null}
   */
  getSelectedShippingMethod() {
    const checked = this.checkboxTargets.filter((checkboxElement) => checkboxElement.checked);

    return checked.length ? checked[0] : null;
  }

  /**
   * @return {Number}
   */
  getSelectedShippingMethodPrice() {
    const checkedShippingMethod = this.getSelectedShippingMethod();

    if (!checkedShippingMethod) {
      return 0;
    }

    return parseFloat(checkedShippingMethod.getAttribute('data-price'));
  }

  handleShippingCosts() {
    this.sendShippingCostsToCartSummary(this.getSelectedShippingMethodPrice());
  }

  sendShippingCostsToCartSummary(shippingMethodPrice) {
    const cartSummaries = toArray(document.querySelectorAll('[data-controller="cart-summary"]'));

    cartSummaries.forEach((summaryElement) => {
      getControllerForElement(this.application, summaryElement, 'cart-summary')
        .then((controller) => {
          controller.setShippingCosts(shippingMethodPrice);
        });
    });
  }
}

ShippingPageController.targets = [
  'checkbox',
];

export default ShippingPageController;
